module.exports = __webpack_public_path__ + "img/Microphone - Blue - Selected.44b81f0e.png";